<template>
  <div>
    <Header page="subject"/>
    <div id="content">
      <Contents v-if="user_attribute" :target="this.user_attribute.target_subjects" page="subject"/>
      <v-row style="max-width: 900px; margin: 0 auto;">
        <v-col style="text-align: left; padding: 12px 0;">
          <v-btn id="returnBtn" @click="returnAttribute">&lt; 属性選択へ戻る</v-btn>
          <div class="text-left" style="margin-bottom: 24px; font-size: 24px; border-bottom: solid #00a0e9; padding-left: 8px; border-left: 12px solid #faef05;">2. 科目選択</div>
          <div>
            <span style="white-space: pre-wrap;">{{ setting.subject_description }}</span>
          </div>
          <div style="text-align: center;">
            <v-btn
              id="nextBtnSmall"
              v-on:click="doNext()"
            >
              <div>
                <span style="font-size: 24px; display: inline-block; margin-bottom: -6px;">科目選択をスキップ</span><br>
              </div>
            </v-btn>
          </div>
          <div id="enquete"
            style="margin: 24px 0 36px 0;">
            <v-card-title style="width: 100%; justify-content: center; position:sticky; top:0; z-index:1; background-color: #FFF;" id="subjectTitle">
              <template v-for="(subject, index) in subject_categories">
                <v-btn id="categoryBtn" :value="index == selectedPage" @click="selectSubject(index)" :key="index">{{ subject.category_name }}</v-btn>
              </template>
            </v-card-title>
            <div style="align-items: center; display: flex; justify-content: space-between; width: 100%; position:sticky; top:0; z-index:1; background-color: #FFF;" class="mt-1 mb-1" id="selectBtnDiv">
              <v-btn @click="selectedPage--" :disabled="selectedPage == 0" id="selectBtnSmall" style="margin-bottom: 16px;"><span style="color: blue;">◀</span>前へ</v-btn>
              <v-btn @click="selectedPage++"
                :disabled="selectedPage + 1 == subject_categories.length" id="selectBtnSmall" style="margin-bottom: 16px;">次へ<span style="color: blue;">▶</span></v-btn>
            </div>
            <v-card style="min-height: 460px; border: #666 solid 1px;">
              <v-card-title class="flex-nowrap" id="subjectHeader">
                <div v-if="$vuetify.breakpoint.mdAndUp" style="width: 34%;"></div>
                <template v-for="(header, index) in headers">
                  <div v-if="header.text=='未履修' || index == 0" :key="header.text"
                    class="text-md-body-1 text-sm-body-2 text-caption subjectDefault">
                    {{ header.text }}
                    <v-btn v-on:click="selectReload" id="select-reload"><svg-icon style="width: 20px; height: 20px;" type="mdi" :path="path"/></v-btn>
                    <v-dialog v-if="dialog" v-model="dialog" width="90%" max-width="600px">
                      <v-card>
                        <v-card-title style="text-align: left;">
                          {{ subject_categories[selectedPage].category_name }} をすべて未履修に戻しますか？
                        </v-card-title>
                        <v-card-text style="text-align: right;">
                          <v-btn @click="closeDialog"
                            style="background-color: #FFF; color: #000; font-size: 16px; font-weight: bold; min-width: 6em; height: 3em; margin-top: 12px; margin-bottom: 6px; margin-right: 12px;">キャンセル</v-btn>
                          <v-btn @click="reload"
                            style="background-color: #E76F00; color: #FFF; font-size: 16px; font-weight: bold; min-width: 6em; height: 3em; margin-top: 12px; margin-bottom: 6px;">OK</v-btn>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>
                  <div v-else style="justify-content: center; flex: 1; width: 10%;" :key="header.text"
                    class="text-md-body-1 text-sm-body-2 text-caption">
                    {{ header.text }}
                    <v-btn v-if="index == 0" v-on:click="selectReload" id="select-reload"><svg-icon style="width: 20px; height: 20px;" type="mdi" :path="path"/></v-btn>
                    <v-dialog v-if="dialog" v-model="dialog" width="90%" max-width="600px">
                      <v-card>
                        <v-card-title style="text-align: left;">
                          {{ subject_categories[selectedPage].category_name }} をすべて未履修に戻しますか？
                        </v-card-title>
                        <v-card-text style="text-align: right;">
                          <v-btn @click="closeDialog"
                            style="background-color: #FFF; color: #000; font-size: 16px; font-weight: bold; min-width: 6em; height: 3em; margin-top: 12px; margin-bottom: 6px; margin-right: 12px;">キャンセル</v-btn>
                          <v-btn @click="reload"
                            style="background-color: #E76F00; color: #FFF; font-size: 16px; font-weight: bold; min-width: 6em; height: 3em; margin-top: 12px; margin-bottom: 6px;">OK</v-btn>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>
                </template>
              </v-card-title>
              <template v-for="subject in categoryOfSelectedPage.subjects">
                <v-radio-group class="subject-group" v-model="subject.result" row :key="subject.name"
                  dense>
                  <div class="d-flex flex-md-row flex-column" style="width:100%">
                    <div id="subjectName"
                      class="text-md-center text-left text-md-body-1 text-sm-body-2 text-caption pa-2">{{
                        subject.name
                      }}
                    </div>
                    <div class="d-flex flex-grow-1">
                      <v-radio :key="0" checked
                        class="flex-grow-1 radioBtnDefault" color="#FF00FF" :value="0" @change="doResult(subject, 0)">
                      </v-radio>
                      <v-radio v-for="n in 5" :key="n"
                        class="flex-grow-1 radioBtn" :value="n" @change="doResult(subject, n)">
                      </v-radio>
                    </div>
                  </div>
                </v-radio-group>
              </template>
            </v-card>
            <div style="align-items: center; display: flex; justify-content: space-between;" class="mt-1 mb-1">
              <v-btn @click="selectedPage--" :disabled="selectedPage == 0" id="selectBtnSmall" style="margin-top: 16px;"><span style="color: blue;">◀</span>前へ</v-btn>
              <v-btn @click="selectedPage++"
                :disabled="selectedPage + 1 == subject_categories.length" id="selectBtnSmall" style="margin-top: 16px;">次へ<span style="color: blue;">▶</span></v-btn>
            </div>
          </div>
          <div style="text-align: center;">
            <v-btn
              id="nextBtn"
              v-on:click="doNext()"
            >
              <div>
                <span style="font-size: 24px; display: inline-block; margin-bottom: -6px;">マッチング結果へ</span><br>
                <span style="font-size: 12px;">入力途中でも結果へ進めます</span>
              </div>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
import Header from "../components/header.vue";
import Contents from "../components/contents.vue";
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiReload } from '@mdi/js';

export default {
  name: "my-component",
  data() {
    return {
      setting: [],//可変の設定
      subject_categories: [],//科目カテゴリ一覧
      dialog: false,
      selectedPage: 0,//表示しているページ数
      user_attribute: {},//来訪user
      path: mdiReload,
    }
  },
  created() {
    window.addEventListener('resize', () => {
      if(document.getElementById("subjectHeader")){
        document.getElementById("subjectHeader").style.top = (document.getElementById('subjectTitle').offsetHeight + document.getElementById('selectBtnDiv').offsetHeight) + "px";
        document.getElementById("selectBtnDiv").style.top = document.getElementById('subjectTitle').offsetHeight + "px";
      }
    });
    this.user_attribute = JSON.parse(localStorage.getItem('user_attribute'));
    if (!this.user_attribute) {//ユーザ属性のpropsがない場合の処理
      this.$router.push({ name: 'home' });
    }
    else {
      this.subject_categories = this.$repository.getSubjectCategories(this.user_attribute);
    }
    this.setting = this.$repository.setting;
    //保持機能
    if (!localStorage.getItem('subjects_answer_status')) {
      this.holdAttribute();
    }
    else {
      let user_subjects = JSON.parse(localStorage.getItem('subjects_answer_status'));//保持されている属性
      let user_subject = [];//user属性の選択科目
      //属性の科目が保持されているか
      if (user_subjects[this.user_attribute.name]) {
        user_subject = user_subjects[this.user_attribute.name];
        for (let index = 0; index < this.subject_categories.length; index++) {
          for (let count = 0; count < this.subject_categories[index].subjects.length; count++) {
            this.subject_categories[index].subjects[count].result = user_subject[this.subject_categories[index].subjects[count].name];
          }
        }
      }
      else {
        this.holdAttribute();
      }
    }
  },
  methods: {
    selectSubject(index) {
      this.selectedPage = index;
    },
    returnAttribute() {
      this.$router.push({ name: 'home'});
    },
    doNext() {
      this.$router.push({ name: 'favorite' });
    },
    closeDialog() {
      this.dialog = false;
    },
    selectReload() {
      this.dialog = true;
    },
    reload() {
      this.subject_categories[this.selectedPage].subjects.map(subject => this.doResult(subject, 0))
      this.dialog = false;
    },
    doResult(subject, num) {
      let user_subjects = JSON.parse(localStorage.getItem('subjects_answer_status'));
      let user_subject = user_subjects[this.user_attribute.name];
      user_subject[subject.name] = num
      user_subjects[this.user_attribute.name] = user_subject;
      user_subjects = JSON.stringify(user_subjects);
      localStorage.setItem('subjects_answer_status', user_subjects);
      subject.result = num

      return subject;
    },
    scrollToEnquete() {
      const enqueteElement = document.getElementById("enquete");
      window.scrollTo(0, enqueteElement.offsetTop - 60)
    },
    holdAttribute() {
      //属性ごとのuserの得意科目の値を保存する処理
      let user_subjects = {};//userの選択した数値
      for (let index = 0; index < this.subject_categories.length; index++) {
        for (let count = 0; count < this.subject_categories[index].subjects.length; count++) {
          this.subject_categories[index].subjects[count].result = 0;//初期状態を0(未履修にする)処理
          user_subjects[this.subject_categories[index].subjects[count].name] = this.subject_categories[index].subjects[count].result;
        }
      }
      let user_subject = {};
      if (localStorage.getItem('subjects_answer_status')) {
        user_subject = JSON.parse(localStorage.getItem('subjects_answer_status'));
      }
      user_subject[this.user_attribute.name] = user_subjects;
      localStorage.setItem('subjects_answer_status', JSON.stringify(user_subject));
    }
  },
  mounted() {
    document.getElementById("subjectHeader").style.top = (document.getElementById('subjectTitle').offsetHeight + document.getElementById('selectBtnDiv').offsetHeight) + "px";
    document.getElementById("selectBtnDiv").style.top = document.getElementById('subjectTitle').offsetHeight + "px";
  },
  components: {
    Header,
    Footer,
    Contents,
    SvgIcon,
  },
  computed: {
    categoryOfSelectedPage() {
      if (this.subject_categories.length == 0) {
        return;
      }
      return this.subject_categories[this.selectedPage]
    },
    headers() {
      if (this.user_attribute.subject_answer_options) {
        return this.user_attribute.subject_answer_options.map(option => {
          return { text: option }
        })
      } else {
        return [
          { text: "未履修", },
          { text: "苦手", },
          { text: "やや苦手", },
          { text: "普通", },
          { text: "やや得意", },
          { text: "得意", },
        ]
      }
    }
  },
  watch: {
    selectedPage: function () {
      this.scrollToEnquete()
    }
  }
}
</script>

<style scoped>
/*スマホ画面*/
#content {
  width: auto;
  max-width: 900px;
  margin: 0 5%;
  padding: 0;
}
.subjectDefault {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 12px;
  flex: 1;
  width: 10%;
}
.radioBtnDefault {
  justify-content: center;
  width: 10%;
}
.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: -4px;
}
.radioBtn {
  justify-content: center;
  width: 10%;
}
#categoryBtn {
  box-shadow: none;
  border: none;
  font-size: 16px;
  background: transparent;
  border-radius: 0%;

}
#categoryBtn[value="true"] {
  font-weight: bold;
  border-bottom: solid 1px black;
}
#selectBtn {
  box-shadow: none;
  border: solid 1px #666;
  margin-top: 24px;
  font-size: 16px;
  background-color: aliceblue;
  width: 30vw;
  height: 4em;
  border-radius: 4px;
}
#selectBtnSmall {
  box-shadow: none;
  font-size: 16px;
  background-color: #FFF;
  width: 15vw;
  height: 2em;
  border-radius: 4px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
#nextBtn {
  background-color: #E76F00;
  color: #FFF;
  width: 100%;
  height: 6em;
  margin-top: 24px;
  margin-bottom: 152px;
}
#nextBtnSmall {
  background-color: #E76F00;
  color: #FFF;
  width: 100%;
  height: 6em;
  margin-top: 48px;
  margin-bottom: 24px;
}
#returnBtn {
  background-color: #FFF;
  border: solid 1px black;
  width: 100%;
  height: 3em;
  margin-bottom: 48px;
  box-shadow: none;
}
#subjectHeader {
  border-bottom: solid 3px#D9D9D9;
  justify-content: center;
  padding-left: 0px;
  padding-right: 0px;
  position:sticky;
  z-index:1;
  background: aliceblue;
  text-align: center;
  top: 0;
}
.subject-group {
  border-bottom: solid 2px#D9D9D9;
}
#subjectName {
  width: 100%;
}
#select-reload {
  padding: 0;
  min-height: 32px;
  min-width: 32px;
  margin-top: -6px;
  border-left: 24px;
  box-shadow: none;
  border: none;
  font-size: 16px;
  background: transparent;
  border-radius: 0%;
}
/*タブレット画面*/
@media (min-width: 450px) {
  #subjectName {
    margin-left: 3vw;
  }
  #categoryBtn {
    font-size: 20px;
  }
  #selectBtn {
    width: 10em;
    height: 4em;
  }
  #selectBtnSmall {
    width: 5em;
    height: 2em;
  }
  #nextBtn {
    width: 25em;
  }
  #nextBtnSmall {
    width: 25em;
  }
  #returnBtn {
    width: 12em;
  }
}
/*PC画面*/
@media (min-width: 960px) {
  #content {
    margin: 0 auto;
    width: 900px;
  }
  #subjectName {
    margin-left: 0;
    width: 34%;
  }
  #subjectHeader {
    padding-right: 24px;
  }
  .subject-group {
    padding-right: 24px;
  }
  .subjectDefault {
    white-space: nowrap;
    flex-direction: row;
    margin-left: 18px;
    margin-right: 12px;
    margin-top: 0;
    width: 16%;
  }
  .radioBtnDefault {
    padding-right: 24px;
    width: 16%;
  }
}
.theme--light.v-btn.v-btn--disabled {
  background-color: #FFF !important;
  color: black !important;
  Opacity: 50%;
}
</style>